import Phaser from 'phaser'

export default class SpritePool
{
    constructor(type, length, parentRef)
    {
        this.pool = [];
        var i = length;
        while (--i > -1)
        {
            this.pool[i] = new type(parentRef).setVisible(false);
        }
    }

    getSprite()
    {
        if (this.pool.length > 0)
        {
            return this.pool.pop().setVisible(true);
        }
        else
        {
            throw new Error("You ran out of sprites!");
        }
    }

    returnSprite(sprite)
    {
        this.pool.push(sprite);
        sprite.setVisible(false);
    }
}